import { render, staticRenderFns } from "./AdvisoryFutureQuestions.vue?vue&type=template&id=1b4445fc&scoped=true"
import script from "./AdvisoryFutureQuestions.vue?vue&type=script&lang=js"
export * from "./AdvisoryFutureQuestions.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryFutureQuestions.vue?vue&type=style&index=0&id=1b4445fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4445fc",
  null
  
)

export default component.exports